import { prepare } from './PrepareTrackingDataHelper';

export default { prepare };
